export default __webpack_public_path__ + "static/media/icon-my-profile-1.27e25b07.svg";